jQuery(document).ready(function ($) {
  // Images
  $('img').each(function () {
    var img = $(this);
    var src = $(this).attr('src');
    var alt = $(this).attr('alt');
    var filename = src.split('/').reverse()[0].replace(/\.[^/.]+$/, '');
    if (img.parent('a').length !== 0) {
      console.log('parent is a link');
      if (alt === '' || alt === undefined) {
        img.attr('alt', 'image ' + filename);
      }
    } else {
      if (alt === '' || alt === undefined) {
        img.attr('alt', '');
      }
    }
  });

  // Tables
  $('main').responsiveTables();

  //Blockquote functionality if image is being used
  $('blockquote').each(function () {
    if ($(this).find('img').length) {
      $(this).wrap('<div class="blockquote"></div>');
      // $('.blockquote blockquote').wrapInner('<p></p>');
      $('blockquote p > img').unwrap();
    }
  });

  $('.modal .modal-content').each(function () {
    if ($(this).find('img').length) {
      $('.modal .modal-content img').unwrap();
      $('.modal .modal-content img').wrap('<div class="image"></div>');
      $(this).parent().css('min-height', '400px');
    }
  });

  //Blog Categories
  $('.blog-category-title').click(function () {
    $('.blog-categories').toggleClass('active');
  });

  $('.blog-category-title').on('keypress', function (e) {
    if (e.which === 13) {
      $('.blog-categories').toggleClass('active');
    }
  });

  //Paging
  if ($('.paging.products ul.pagination li a').hasClass('active')) {
    $('.paging.products ul.pagination li a.active').parent().prevAll().remove();
  }

  if ($('ul.pagination').is(':empty')) {
    $('.paging').remove();
  }

});